import logoBrand from '@/assets/images/logo_basciano.svg'
import { Button } from '@/components/atoms/Button/Button'
import { LanguageSelector } from '@/components/molecules/LanguageSelector/LanguageSelector'
import { Logo } from '@/components/molecules/Logo/Logo'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@radix-ui/react-collapsible'
import { ChevronsUpDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface MenuMobileProps {
  closeModal: () => void
  isNotHome?: boolean
}

export function MenuMobile ({ closeModal, isNotHome = false }: MenuMobileProps): JSX.Element {
  const { t } = useTranslation()
  const navigate = useNavigate()

  // Función para manejar el scroll al hacer clic en los enlaces
  const handleScroll = (sectionId: string): void => {
    if (isNotHome) {
      navigate('/')
      setTimeout(() => {
        const section = document.getElementById(sectionId)
        if (section != null) {
          section.scrollIntoView({ behavior: 'smooth' })
        }
      }, 200)
    } else {
      // De lo contrario, desplázate a la sección correspondiente
      const section = document.getElementById(sectionId)
      if (section != null) {
        section.scrollIntoView({ behavior: 'smooth' })
      }
    }

    closeModal()
  }

  const goToPage = (url: string): void => {
    navigate(url)
    closeModal()
  }

  return (
    <header className='w-full min-w-full min-h-screen'>
      <div className='pt-6 pl-4'>
        <Logo
          src={logoBrand}
          alt='Basciano Trading Logo'
          width={200}
          height={80}
        />
      </div>
      <ul className='flex flex-col items-start gap-4 mt-4 p-8'>
        <li>
          <button
            onClick={() => handleScroll('home')}
            className='text-primary hover:text-secondary font-bold'
          >
            {t('header.home')}
          </button>
        </li>
        <li>
          <button
            onClick={() => handleScroll('aboutUs')}
            className='text-primary hover:text-secondary font-bold'
          >
            {t('header.about')}
          </button>
        </li>
        <li>
          <Collapsible className='w-[auto] space-y-2'>
            <div className='flex items-center justify-between'>
              <CollapsibleTrigger asChild>
                <button className='flex items-center gap-1 text-primary font-bold hover:text-secondary'>
                  {t('header.services')}
                  <ChevronsUpDown className='h-4 w-4' />
                </button>
              </CollapsibleTrigger>
            </div>
            <CollapsibleContent className='w-full flex-1 space-y-2 mt-2 bg-white p-4 rounded-[10px] border border-gray-200'>
              <div className='min-w-[auto]'>
                <div className='flex gap-2 items-center p-2' onClick={() => goToPage('/bussines')}>
                  <p className='text-primary border-none m-0 p-0'>{t('header.bussines')}</p>
                </div>
              </div>
            </CollapsibleContent>
          </Collapsible>
        </li>
        <li>
          <button
            onClick={() => handleScroll('formContactUs')}
            className='text-primary hover:text-secondary font-bold'
          >
            {t('header.contact')}
          </button>
        </li>
        <Button className='w-full'>{t('header.login')}</Button>
        <LanguageSelector />
      </ul>
    </header>
  )
}
